// extracted by mini-css-extract-plugin
export default {"Message":"campaignAdhocTemplateView_Message__woJi1"};